/* eslint max-len: 'off' */
import React from 'react'

function Back() {
  return (
    <svg
      width="36px"
      height="36px"
      viewBox="0 0 36 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>back</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g id="back" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-7-Copy" transform="translate(1.000000, 1.000000)">
          <g
            id="cube-copy"
            opacity="0.256026786"
            fill="#000000"
            fillRule="nonzero"
          >
            <path
              d="M33.8017109,6.21575781 L27.7843086,0.198355469 C27.6572734,0.0713867187 27.4850156,0 27.3053867,0 L0.677277344,0 C0.677277344,0 0.67628125,0.0006640625 0.675019531,0.00159375 C0.588492187,0.001859375 0.501234375,0.0170664062 0.418027344,0.05153125 C0.165085937,0.156386719 0,0.403417969 0,0.677277344 L0,27.3053203 C0,27.4849492 0.0713867187,27.6572734 0.198355469,27.7842422 L6.21575781,33.8016445 C6.34531641,33.9312031 6.51857031,34 6.6948125,34 C6.69501172,34 6.69527734,34 6.69547656,34 L33.3227227,34 C33.6967227,34 34,33.6967891 34,33.3227227 L34,6.69467969 C34,6.50761328 33.9242305,6.33834375 33.8017109,6.21575781 Z M6.01740234,26.628043 L5.16846484,26.628043 C4.79446484,26.628043 4.4911875,26.9312539 4.4911875,27.3053203 C4.4911875,27.6793867 4.79446484,27.9825977 5.16846484,27.9825977 L6.01740234,27.9825977 L6.01740234,31.6876016 L2.23377344,27.9039727 C2.44833203,27.7903516 2.59469141,27.5650352 2.59469141,27.3053203 C2.59469141,26.9312539 2.29141406,26.628043 1.91741406,26.628043 L1.35455469,26.628043 L1.35455469,2.31239844 L6.01733594,6.97517969 L6.01733594,26.628043 L6.01740234,26.628043 Z M2.31246484,1.35455469 L26.6281094,1.35455469 L26.6281094,3.92826172 C26.6281094,4.30232812 26.9313867,4.60553906 27.3053867,4.60553906 C27.6793867,4.60553906 27.9826641,4.30232812 27.9826641,3.92826172 L27.9826641,2.31246484 L31.6876016,6.01740234 L6.9753125,6.01740234 L2.31246484,1.35455469 Z M32.6454453,31.6876016 L32.3818125,31.4240352 C32.11725,31.1595391 31.6885313,31.1595391 31.4239023,31.4240352 C31.1594063,31.6885313 31.1594063,32.1173828 31.4239023,32.3818789 L31.6874688,32.6454453 L7.37195703,32.6454453 L7.37195703,27.9826641 L8.41944922,27.9826641 C8.79344922,27.9826641 9.09672656,27.6794531 9.09672656,27.3053867 C9.09672656,26.9313203 8.79344922,26.6281094 8.41944922,26.6281094 L7.37195703,26.6281094 L7.37195703,7.37195703 L26.6281094,7.37195703 L26.6281094,10.4302969 C26.6281094,10.8043633 26.9313867,11.1075742 27.3053867,11.1075742 C27.6793867,11.1075742 27.9826641,10.8043633 27.9826641,10.4302969 L27.9826641,7.37195703 L32.6454453,7.37195703 L32.6453789,31.6876016 L32.6454453,31.6876016 Z"
              id="Shape"
            />
            <path
              d="M27.5,19 C27.2238945,19 27,19.2633446 27,19.5882285 L27,22.4117715 C27,22.7366554 27.2238455,23 27.5,23 C27.7761055,23 28,22.7366554 28,22.4117715 L28,19.5882285 C28,19.2633446 27.7761055,19 27.5,19 Z"
              id="Shape"
            />
            <path
              d="M27.5,13 C27.2238945,13 27,13.2633446 27,13.5882285 L27,16.4117715 C27,16.7366554 27.2238455,17 27.5,17 C27.7761055,17 28,16.7366554 28,16.4117715 L28,13.5882285 C28,13.2633446 27.7761055,13 27.5,13 Z"
              id="Shape"
            />
            <path
              d="M13.4117715,27 L10.5882285,27 C10.2634023,27 10,27.2238455 10,27.5 C10,27.7761545 10.2634023,28 10.5882285,28 L13.4117715,28 C13.7365977,28 14,27.7761545 14,27.5 C14,27.2238455 13.7365977,27 13.4117715,27 Z"
              id="Shape"
            />
            <path
              d="M21.4117715,27 L18.5882285,27 C18.2634023,27 18,27.2238455 18,27.5 C18,27.7761545 18.2634023,28 18.5882285,28 L21.4117715,28 C21.7365977,28 22,27.7761545 22,27.5 C22,27.2238455 21.7365977,27 21.4117715,27 Z"
              id="Shape"
            />
            <path
              d="M29.8106024,29.917827 L27.8051974,27.9517653 L27.8051974,27.6339508 C27.8051974,27.283814 27.5156405,27 27.1585605,27 C26.819867,27 26.5419127,27.2553456 26.5141426,27.5803705 L24.6466369,27.5803705 C24.2895569,27.5803705 24,27.8641845 24,28.2143212 C24,28.564458 24.2895569,28.848272 24.6466369,28.848272 L26.8906236,28.848272 L28.8960921,30.8143337 C29.0223888,30.9381527 29.187868,31 29.3533472,31 C29.5188264,31 29.6843056,30.9380905 29.8106024,30.8143337 C30.0631325,30.56682 30.0631325,30.1654028 29.8106024,29.917827 Z"
              id="Shape"
            />
          </g>
          <rect
            id="Rectangle-8-Copy"
            fill="#9C43C2"
            opacity="0.28203125"
            x="0"
            y="0"
            width="28"
            height="28"
            rx="1"
          />
        </g>
      </g>
    </svg>
  )
}

export default Back
